// extracted by mini-css-extract-plugin
export default {"registrationBox":"RegistrationFormTemplate_registrationBox__FYhx5"};